<template>
  <div class="modal rounded" :class="{'has-description': content.description}">
    <a :href="content.src" :title="content.name" target="_blank" class="download-link"><i class="material-icons">cloud_download</i> {{content.name}}</a>
    <div v-if="content.description" v-html="content.description" class="description"></div>
  </div>
</template>

<script>
import { modalMixin } from '@/mixins/modalMixin.js'
export default {
  name: 'image-modal',
  mixins: [modalMixin],
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  
  .description {
    flex: 1;
    max-width: 300px;
    padding: 20px;
  }
  .download-link {
    color: #3d3dde;
    font-size: 26px;
    text-decoration: none;

    &:hover {
      color: #e1651d;
    }
  }
}
</style>